// Géométrie partagée des jauges demi-anneau (MarketMoodGauge, FearGreedGauge) :
// demi-anneau centré en (GAUGE_CX, GAUGE_CY), score 0 à gauche, 100 à droite.
export const GAUGE_CX = 100;
export const GAUGE_CY = 100;
export const GAUGE_R_OUTER = 80;
export const GAUGE_R_INNER = 60;
export const GAUGE_NEEDLE_LENGTH = 70;

export interface GaugeZone {
    from: number;
    to: number;
    color: string;
}

export const gaugePoint = (score: number, radius: number): { x: number; y: number } => {
    const angle = Math.PI * (1 - score / 100);
    return { x: GAUGE_CX + radius * Math.cos(angle), y: GAUGE_CY - radius * Math.sin(angle) };
};

export const gaugeBandPath = (from: number, to: number): string => {
    const o1 = gaugePoint(from, GAUGE_R_OUTER);
    const o2 = gaugePoint(to, GAUGE_R_OUTER);
    const i2 = gaugePoint(to, GAUGE_R_INNER);
    const i1 = gaugePoint(from, GAUGE_R_INNER);
    return [
        `M ${o1.x} ${o1.y}`,
        `A ${GAUGE_R_OUTER} ${GAUGE_R_OUTER} 0 0 1 ${o2.x} ${o2.y}`,
        `L ${i2.x} ${i2.y}`,
        `A ${GAUGE_R_INNER} ${GAUGE_R_INNER} 0 0 0 ${i1.x} ${i1.y}`,
        'Z',
    ].join(' ');
};

/** Aiguille dessinée verticale (score 50), puis tournée : -90° à 0, +90° à 100. */
export const gaugeNeedleRotation = (score: number): number => (score - 50) * 1.8;

export const clampScore = (score: number): number => Math.min(100, Math.max(0, score));
